import { useIntl } from 'react-intl';
import { ReactComponent as FinanceGuyAvatar } from '@assets/images/illustrations/finance_guy_avatar.svg';
import { ReactComponent as MaleAvatar } from '@assets/images/illustrations/male_avatar.svg';
import { ReactComponent as Avatars } from '@assets/images/illustrations/avatars.svg';
import { ReactComponent as TimeTrackerLogo } from '@assets/images/time_tracker_logo.svg';
import { ReactComponent as UndrawOpenedMail } from '@assets/images/illustrations/undraw_opened_primary.svg';

export const useOptionPickerView = () => {
  const intl = useIntl();
  const PATHS = {
    DT: '/dt',
    OPERONDA: '/signin',
  };
  const access = [
    {
      title: intl.formatMessage({ id: 'work.direction.employer' }),
      Icon: FinanceGuyAvatar,
      href: PATHS.OPERONDA,
    },
    {
      title: intl.formatMessage({ id: 'work.direction.employees' }),
      Icon: MaleAvatar,
      href: PATHS.OPERONDA,
    },
    {
      title: intl.formatMessage({ id: 'work.direction.third.party.companies' }),
      Icon: Avatars,
      href: PATHS.OPERONDA,
    },
    {
      title: intl.formatMessage({ id: 'work.direction' }),
      Icon: TimeTrackerLogo,
      href: PATHS.DT,
    },
    {
      title: intl.formatMessage({ id: 'work.direction.portal.create.email' }),
      Icon: UndrawOpenedMail,
      hrefs: [
        {
          title: 'Yahoo',
          pathname: 'https://login.yahoo.com/account/create?.lang=es-ES&.intl=es',
        },
        {
          title: 'Gmail',
          pathname:
            'https://accounts.google.com/signup/v2/webcreateaccount?hl=es&flowName=GlifWebSignIn&flowEntry=SignUp',
        },
        {
          title: 'Hotmail',
          pathname:
            'https://signup.live.com/signup?nopa=2&client_id=0000000048183522&contextid=193066E0E5F44161&opid=FBD726638F5A6F7C&bk=1680441452&sru=ht&lic=1&uaid=83f95ce09b2245dd99e3e068359fcf7d&username=prefillUserName',
        },
      ],
    },
  ];

  return {
    access,
    PATHS,
  };
};
